import { render, staticRenderFns } from "./CruiseDetailRow.vue?vue&type=template&id=2d53808f&scoped=true"
import script from "./CruiseDetailRow.vue?vue&type=script&lang=js"
export * from "./CruiseDetailRow.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailRow.vue?vue&type=style&index=0&id=2d53808f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d53808f",
  null
  
)

export default component.exports